import template from './MarketplaceOnboarding.html';
import './MarketplaceOnboarding.scss';
import blipChatHealth from './img/blip-chat-health.svg';
import { HOME_TEMPLATE_DOCUMENTATION_OPENED } from '../HomeSegmentEvents';
export class MarketplaceOnboardingController {
    static $inject = ['$window', 'SegmentService'];
    constructor($window, SegmentService) {
        'ngInject';
        this.$window = $window;
        this.SegmentService = SegmentService;
        this.blipChatHealthImg = blipChatHealth;
    }
    async openSuuportMaterial() {
        await this.createTrack(HOME_TEMPLATE_DOCUMENTATION_OPENED);
        this.$window.open(this.supportWeblink, '_blank');
    }
    async createTrack(name) {
        await this.SegmentService.createApplicationTrack({
            trackEvent: name,
            application: this.application,
            payload: {},
        });
    }
}
MarketplaceOnboardingController.$inject = ['$window', 'SegmentService'];
export const MarketplaceOnboardingComponent = {
    controller: MarketplaceOnboardingController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        supportWeblink: '@?',
        application: '<',
    },
};
